import React from 'react'

// Components
import { FilesManager } from '../_components/FilesManager'

export const ChecksModal = ({ documents }) => {
  return (
    <>
      <FilesManager
        allowDelete={false}
        allowUpload={false}
        draggable={false}
        files={documents}
        title="Files"
        viewType="gallery"
      />
    </>
  )
}
